import CloudGamingContent from "./cloud-gaming-content";

/** Trang Cloud Gaming - Render (/clouds): giao diện mới, dùng nguyên các API Cloud cũ. */
function CloudGamingPage() {
  return <CloudGamingContent />;
}

export default CloudGamingPage;
